import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { useAnchor } from "hooks";
import { Features25Content } from "types/graphql/generated";
import { Committee, TextContainer } from "./components";

interface Props {
  content: Features25Content;
}

const Features25: VFC<Props> = withErrorBoundary(
  ({ content: { title, description, features25list, features25label, features25link, features24committeeList } }) => {
    useAnchor("features25");

    return (
      <StyledFeatures25 className="features25 Content">
        <TextContainer
          title={title}
          description={description}
          link={features25link}
          linkLabel={features25label}
          featuresList={features25list}
        />
        <Committee content={features24committeeList} />
      </StyledFeatures25>
    );
  },
  {}
);

const StyledFeatures25 = styled.section`
  display: flex;
  margin-top: -64px;
  padding-top: 64px;
`;

gql`
  fragment Features25Content on ComponentFeaturesFeatures25 {
    title
    description
    features25link
    features25label
    features25list {
      id
      element
    }
    features24committeeList {
      ...Features25CommitteeContent
    }
  }
`;

export { Features25 };
export type { Props as Features25Props };
